import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { ChatPanel } from './ChatPanel';
interface Particle {
  id: number;
  top: string;
  left: string;
  delay: string;
  dx: string; // idle horizontal drift
  bx: string; // burst x
  by: string; // burst y
  size: string;
  color: string;
}
const PARTICLES: Particle[] = [{
  id: 0,
  top: '-10px',
  left: '12px',
  delay: '0s',
  dx: '-4px',
  bx: '-38px',
  by: '-48px',
  size: '5px',
  color: '#74c0fc'
}, {
  id: 1,
  top: '4px',
  left: '-10px',
  delay: '0.5s',
  dx: '-6px',
  bx: '-50px',
  by: '-20px',
  size: '4px',
  color: '#a5d8ff'
}, {
  id: 2,
  top: '-8px',
  left: '36px',
  delay: '1s',
  dx: '5px',
  bx: '44px',
  by: '-44px',
  size: '6px',
  color: '#4dabf7'
}, {
  id: 3,
  top: '30px',
  left: '-8px',
  delay: '1.5s',
  dx: '-3px',
  bx: '-46px',
  by: '30px',
  size: '4px',
  color: '#74c0fc'
}, {
  id: 4,
  top: '34px',
  left: '40px',
  delay: '0.8s',
  dx: '4px',
  bx: '48px',
  by: '36px',
  size: '5px',
  color: '#a5d8ff'
}];
export function ChatBubble() {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [burstKey, setBurstKey] = useState(0);
  const handleMouseEnter = () => {
    setHovered(true);
    setBurstKey(k => k + 1);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  return <>
      <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-13" />

      {/* Wrapper keeps particles in flow with the button */}
      <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40" style={{
      width: 56,
      height: 56
    }} data-id="element-14">
        {/* Particles */}
        {PARTICLES.map(p => <span key={`${p.id}-${burstKey}`} className={`ember${hovered ? ' ember-burst-active' : ''}`} style={{
        top: p.top,
        left: p.left,
        width: p.size,
        height: p.size,
        background: p.color,
        animationDelay: hovered ? '0s' : p.delay,
        animationDuration: hovered ? '0.55s' : `${2.2 + p.id * 0.3}s`,
        '--dx': p.dx,
        '--bx': p.bx,
        '--by': p.by
      } as React.CSSProperties} data-id="element-15" />)}

        {/* Button */}
        <button onClick={() => setIsOpen(!isOpen)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} aria-label="Open AI chat assistant" style={{
        width: 56,
        height: 56,
        background: '#0577FF',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        transform: hovered ? 'scale(1.12)' : isOpen ? 'scale(0.92)' : 'scale(1)',
        boxShadow: hovered ? '0 0 0 6px rgba(5,119,255,0.18), 0 0 24px 6px rgba(5,119,255,0.35), 0 8px 24px rgba(0,0,0,0.18)' : '0 4px 16px rgba(0,0,0,0.18)'
      }} className="relative rounded-full flex items-center justify-center" data-id="element-16">
          {/* Idle pulse ring (only when closed & not hovered) */}
          {!isOpen && !hovered && <span className="absolute inset-0 rounded-full animate-ping opacity-20" style={{
          background: '#0577FF'
        }} data-id="element-17" />}

          {isOpen ? <X size={22} className="text-white relative z-10" data-id="element-18" /> : <Sparkles size={22} className="text-white relative z-10" data-id="element-19" />}

          {/* Unread badge */}
          {!isOpen && <span className="absolute -top-1 -right-1 w-5 h-5 bg-accent-600 rounded-full text-xs font-bold text-white flex items-center justify-center z-10" data-id="element-20">
              1
            </span>}
        </button>
      </div>
    </>;
}